import { PLANNINGS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: PLANNINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkPlannings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/plannings/index.js